import { inView } from "//de.ringconn.com/cdn/shop/t/52/assets/vendor.min.js?v=110209841862038618801786686886";

class animateFadeIn extends HTMLElement {
  constructor() {
    super(); 
    this.animatedElements = this.querySelectorAll('[data-animate]');
  }

  connectedCallback() { 
    this.setupInViewAnimation();
  }

setupInViewAnimation() {
    this.animatedElements.forEach(element => {
      inView(element, (isInView) => { 
        const animationType = element.dataset.animate;
        
        if (isInView) {
          element.classList.add(`animate__${animationType}`);
        } else {
          element.classList.remove(`animate__${animationType}`);
        }
      }, { margin: '0px 0px -10% 0px' });
    });
  }
}

if (!customElements.get('animate-fade-in')) {
  customElements.define('animate-fade-in', animateFadeIn);
}
 